import PropTypes from 'prop-types';
import React, { Component } from 'react';
import MicIcon from '../../../../images/vector/mic.svg';
import CheckmarkOutline from '../../../../images/vector/checkmark-outline.svg';
import AudioView from '../../../../common/audio/audioView';
import successSound from '../../../../sounds/success_sound.mp3';

export const MIC_PERMISSIONS_TEST_SUCCESS_TIMEOUT = 1500;

class MicPermissionsTestSuccessCard extends Component {
    constructor(props) {
        super(props);
        this.onDoneTimerId = null;
        this.state = {
            isAudioReadyToPlay: false,
        };
    }

    componentDidMount() {
        this.onDoneTimerId = setTimeout(this.props.onDone, MIC_PERMISSIONS_TEST_SUCCESS_TIMEOUT);
        this.onRender();
    }

    componentWillUnmount() {
        clearTimeout(this.onDoneTimerId);
    }

    onRender = () => this.setState({ isAudioReadyToPlay: true});

    render() {
        return (
            <div className="mic-success-card">
                <div className="instruction-content">
                    <MicIcon />
                    {this.props.text}
                </div>
                <CheckmarkOutline />
                <AudioView audioTracks={[successSound]} isReadyToPlay={this.state.isAudioReadyToPlay} stopAudio={() => {}} />
            </div>
        );
    }
}

MicPermissionsTestSuccessCard.propTypes = {
    text: PropTypes.string.isRequired,
    onDone: PropTypes.func.isRequired,
};

export default MicPermissionsTestSuccessCard;
